import * as React from 'react';
import styled from 'styled-components';

export const Dos = () => (
  <>
    The following constitutes the agreement between you and Trac Technologies,
    Inc. (“Company”) regarding your use of the trac™ platform and distribution
    service (the “Service”). Except where expressly inconsistent, the terms of
    this agreement do not modify the{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="https://app.trac.co/terms-of-service"
    >
      Terms of Service
    </a>{' '}
    and{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="https://app.trac.co/privacy-policy"
    >
      Privacy Policy
    </a>{' '}
    located on Company’s website, both of which govern your use of such website,
    including the Service. For clarity, in the event of any inconsistency
    between this agreement and such Terms of Service or Privacy Policy, the
    terms of this agreement will control.
    <br />
    <br />
    <br />
    <b>1. Service Subscription:</b>
    <br />
    <br />
    <br />
    To make full use of the Service, you are required to establish and maintain
    a Service subscription (“Subscription”). Company may offer any number of
    Subscription plans, including special promotional plans or Subscriptions
    with differing terms, conditions, and limitations. All terms, conditions,
    and limitations of your Subscription will be disclosed or made available to
    you by Company during the Subscription purchase process. Company reserves
    the right to modify, terminate, or otherwise amend Subscription plans in its
    sole discretion. You hereby agree to maintain an active subscription
    throughout the Term (as hereafter defined) hereof, and understand that there
    are no refunds for Subscription payments made prior to any termination
    hereof. Among other things, the failure to maintain an active Subscription
    will result in additional Service Fees (as hereafter defined) and
    limitations on your ability to distribute Content (as hereafter defined).
    <br />
    <br />
    <br />
    <b>2. Grant of Rights:</b>
    <br />
    <br />
    <br />
    During the Term (as hereafter defined) you hereby grant Company the
    following rights throughout the universe (“Territory”) on a fully
    transferable, sub-licensable, basis.
    <br />
    <br />
    (a) You may submit sound recordings, musical works, images, audiovisual
    works, metadata, and related content (collectively, “Content”) for
    distribution through the Service. In doing so, you are granting Company the
    exclusive right to reproduce, distribute, perform, display, adapt, and
    transmit your Content as a part of the Service in accordance with the terms
    herein. Without limiting the generality of the foregoing, you hereby grant
    Company the right to: (i) authorize third-party digital service providers
    and digital music retailers (collectively, “DSPs”) to host your Content;
    (ii) digitally distribute and transmit your Content (whether on an
    interactive or non-interactive basis), including by way of streaming and
    downloading (in whole or in part), on a through to the end user basis, in
    each case, across any and all DSPs, applications, devices, networks,
    platforms, services, stores, and sites, now known or hereafter developed
    (collectively, “Platforms”) on a commercial or promotional (i.e., free of
    charge) basis; (iii) create fingerprints of, reference files relating to,
    metadata concerning or other digital attributes of your Content, to make
    claims in respect of third-party uses of your Content (in whole or in part),
    and to block, permit, whitelist, and monetize such uses, in each case,
    across any and all Platforms; (iv) collect royalties and payments in respect
    of the exploitation of your Content from third parties derived from your use
    of the Service; and (v) make other reasonably necessary uses of your Content
    (in whole or in part) and otherwise exploit, modify, excerpt, encode, host,
    cache, transmit, distribute, store, copy, embed, upload, perform,
    communicate to the public, display, render, market, promote, sell copies of,
    sell advertising against and subscription access to (or otherwise monetize),
    claim, block, disable, or take down your Content (in whole or in part) as a
    part of the Service.
    <br />
    <br />
    (b) You may submit your Content for Company’s consideration in connection
    with Company’s synchronization license representation program (“Synch
    Representation”). To the extent such Content is accepted for Synch
    Representation, you are engaging Company to serve as your exclusive
    licensing representative for purposes of soliciting, procuring, negotiating,
    securing, and administering audio and audiovisual licensing opportunities
    (“Licensing Opportunities”) for such Content in all broadcast, television,
    film, videogame, advertising, commercial, internet, mobile, podcast, and
    similar audio and audiovisual media formats now known or hereafter devised
    (collectively, “Licensed Media”). Without limiting the generality of the
    foregoing, you hereby grant Company the right to: (i) reproduce, distribute,
    perform, transmit, re-title, display, edit, adapt, license, and exploit your
    Content in the Licensed Media and otherwise as Company reasonably deems
    necessary in connection with all Licensing Opportunities; (ii) the right to
    solicit, procure, negotiate, and secure Licensing Opportunities for your
    Content in the Licensed Media (each, a “Secured Use”); (iii) the right to
    identify and clear (i.e., “whitelist”) your Content as embodied in a Secured
    Use on all user generated content sites and platforms (including social
    media sites), and you will ensure that Company has the access necessary to
    do so throughout the Territory at all times during the Term hereof; (iv) the
    right to stream your Content on Company’s owned and controlled website, and
    allow Company’s licensing customers, partners, or clients (each, a “Company
    Client”) to securely download your Content solely for purposes of previewing
    a potential licensing exploitation; and (v) with the sole exception of
    public performance royalties collected and paid by your performance rights
    society (which are unaffected by this agreement), Company will have the
    right to determine the applicable fees for, and collect and administer all
    monies derived from, each Secured Use hereunder.
    <br />
    <br />
    (c) You may use the Service for purposes of direct-to-consumer ecommerce
    sales of physical, digital, or virtual merchandise items (collectively,
    “Merchandise”). In doing so, you are granting Company all necessary rights
    to distribute, display, market, promote, and sell your Merchandise through
    the Service. You will have the right to approve (or supply) all Merchandise
    designs, as well as the types of Merchandise items to be created and
    distributed hereunder and the consumer purchase price thereof. To the extent
    such Merchandise designs are supplied by you, Company will acquire no
    interest therein except as necessary to exercise its merchandising rights
    hereunder as determined by Company in its sole discretion.
    <br />
    <br />
    (d) Company will have the right (but not the obligation) to enforce and
    protect the copyright interest in your Content and Merchandise against
    third-party infringements or other violations, including by way of so-called
    “takedown” requests pursuant to the Digital Millennium Copyright Act. In the
    event that Company elects to pursue (in its sole discretion) any enforcement
    measures, all decisions concerning the enforcement and, if applicable, the
    resolution of such claims will be made by Company in its sole and reasonable
    business judgment. Any recovery derived from such enforcement measures will
    be accounted to you in the same manner as Net Receipts (as hereafter
    defined). In the event that Company declines in writing to pursue any such
    claims, you will have the right to pursue the same and any recovery derived
    therefrom will be retained for your own account.
    <br />
    <br />
    (e) Company will have the right to use and permit others to use your name,
    image, likeness, biographical information, trademarks, trade names, cover
    art, photographs, designs, and other identifying materials related to your
    Content (collectively, the “Identification Materials”), as wells as
    Identification Materials concerning any collaborators, performers, artists,
    producers, and others whose contributions are embodied in your Content or
    Merchandise, as is reasonably necessary (determined at Company’s sole
    discretion) to exploit your Content and Merchandise on all Platforms,
    relative to all Licensing Opportunities, and otherwise in connection with
    your use of the Service. Company will only use Identification Materials
    supplied or approved by you; provided that Company’s inadvertent failure to
    obtain such approval will not be deemed a breach of this agreement. To the
    fullest extent allowable by law, you hereby waive any claims based on
    infringement of your so-called “moral rights” in connection with your
    Content, Merchandise, and Company’s exploitation thereof.
    <br />
    <br />
    (f) Company will at all times maintain the absolute right to decline or
    cease to distribute any Content or Merchandise that, in Company’s sole and
    absolute discretion, may: (i) be obscene, hateful, defamatory, or unlawful;
    (ii) subject Company to liability for any reason; or (iii) constitute a
    breach by you of any of your agreements, covenants, representations, or
    warranties contained herein.
    <br />
    <br />
    <br />
    <b>3. Term & Termination:</b>
    <br />
    <br />
    <br />
    The duration of this agreement (“Term”) will automatically commence as of
    the date (“Effective Date”) your Content or Merchandise is uploaded to the
    Service or otherwise provided to Company, and will continue until such time
    as either party terminates the agreement with notice to the other party,
    except that Company may terminate this agreement without notice in the case
    of your violation of any warranty, representation, agreement, undertaking,
    or covenant contained herein. Company will have thirty (30) days to remove
    any Content or Merchandise from applicable Platforms following the Term. In
    all instances, the suspension or termination hereof for any reason will not
    release either party from any liabilities or obligations that the parties
    have expressly agreed will survive, remain to be performed, or by their
    nature would be intended to survive any such suspension or termination,
    including the representations, warranties, indemnification obligations, and
    any applicable payment obligations. As it relates to Synch Representation,
    upon termination or expiration of the Term hereof (for any reason), Company
    will discontinue actively pitching and marketing your Content. Company may
    continue to negotiate and secure (but not actively solicit or seek to
    procure) Licensing Opportunities solicited or procured by Company prior to
    termination or expiration of the Term for eighteen (18) months thereafter
    and all such Licensing Opportunities will be deemed to be a Secured Use
    during the Term for all purposes hereunder regardless of when actually
    finalized. Notwithstanding anything to the contrary contained herein, the
    termination hereof will have no effect on: (i) the rights granted to
    third-party licensees in connection with a Secured Use during the Term
    (including any options or renewals associated therewith); or (ii) Company’s
    right to continue collecting and otherwise administering all fees, payments,
    royalties, or other monies earned or paid after the Term which are derived
    from a Secured Use. Company will continue to account to you for any amounts
    received in connection with a Secured Use following the Term in accordance
    with the terms herein.
    <br />
    <br />
    <br />
    <b>4. Payments</b>
    <br />
    <br />
    <br />
    You will be entitled to one hundred percent (100%) of Net Receipts (as
    hereafter defined), which will be maintained in a single account on the
    Service (“Service Account”).
    <br />
    <br />
    (a)Payments will be calculated based on one hundred percent (100%) of
    Company’s actual receipts directly attributable to the exploitation of your
    Content and Merchandise sales (collectively, “Gross Receipts”) after first
    deducting the following service fees (“Service Fees”), and any taxes, fees,
    or other charges directly related to the exploitation concerned (the
    resulting amount hereafter referred to as “Net Receipts”).
    <br />
    <br />
    <StyledTable>
      <tbody>
        <tr>
          <th>Source of Gross Receipts</th>
          <th>Subscription Status</th>
          <th>Applicable Service Fee (of Gross Receipts)</th>
        </tr>
        <tr>
          <td rowSpan={2}>
            <i>Platforms & Merchandise</i>
          </td>
          <td>Active Subscription</td>
          <td>Five percent (5%)</td>
        </tr>
        <tr>
          <td>Inactive Subscription</td>
          <td>Fifteen percent (15%)</td>
        </tr>
        <tr>
          <td>
            <i>Synch Representation</i>
          </td>
          <td>∞</td>
          <td>Fifty percent (50%)</td>
        </tr>
      </tbody>
    </StyledTable>
    <br />
    <br />
    (b) With respect to Synch Representation monies derived from any Company
    Client who has obtained a fixed fee subscription to use your Content along
    with other works represented by Company, all Gross Receipts will be prorated
    in Company’s good-faith business discretion among all works (including your
    Content) used by the Company Client during the applicable accounting period,
    taking into account factors such as the quality, nature, classification, and
    duration of the uses made by the Company Client.
    <br />
    <br />
    (c) For clarity, to the extent that your ownership or administration
    interest in the Content licensed is less than one hundred percent (100%), in
    calculating Net Receipts due from Synch Representation hereunder, any monies
    collected by Company will be first prorated equally between the applicable
    composition and recording, and then prorated again based on your interest
    the same.
    <br />
    <br />
    (d) Except as otherwise expressly provided herein, you will be solely
    responsible for all royalties or other monies that are or may become due to
    the individual producers, engineers, mixers, guest artists, third-party
    rightsholders, or other royalty participants in respect of your Content and
    Merchandise.
    <br />
    <br />
    <br />
    <b>5. Accounting & Payment Directives</b>
    <br />
    <br />
    <br />
    Payment to you from the Service Account will be subject to Company’s
    then-current accounting and payment timelines and otherwise in accordance
    with the following.
    <br />
    <br />
    (a) Once payment has been credited to the Service Account, you will be able
    to withdraw all or any portion at your discretion. All withdrawals must be
    made through Company’s then-currently available payment methods. you will be
    solely responsible for any bank fees or other charges related to such
    withdrawals and any payments that may be due to any third-party rights
    holder in connection with the exploitation of your Content, Merchandise, and
    otherwise in connection with your use of the Service. You are solely
    responsible for ensuring the accuracy of information related to withdrawals
    from the Service Account. Company will have no liability whatsoever for any
    erroneous or unintended disbursements made by Company based on the
    inaccuracy of information related to a withdrawal provided by you. Until
    such time as you have made a withdrawal, all Net Receipts posted to the
    Service Account may be pooled in an interest-bearing bank account with the
    Net Receipts of other Service users. You agree that you will not receive
    interest or other earnings or benefit on the Net Receipts that Company
    handles as your agent and places in such pooled account. In consideration
    for your use of the Service, you irrevocably transfer and assign to Company
    any ownership right that you may have in any interest that may accrue on Net
    Receipts held in such pooled account. All payments made hereunder will be
    subject to such deductions and withholdings as may be required by law, and
    you hereby authorize Company to make such deductions and withholdings as
    deemed required in its good faith judgment.
    <br />
    <br />
    (b) To the extent that you have directed Company to make payment (“Payment
    Directive”) of any portion of Net Receipts to other persons, firms, or
    entities (“Payees”), you agree that Company may credit any such Payee’s
    account with the amount indicated in the applicable Payment Directive. All
    credits and payments made through such Payment Directive will be
    irreversible once withdrawn by a Payee, and Company will have no liability
    whatsoever for any erroneous or unintended credits or payments made to
    Payees provided that such credits or payments were in accordance with the
    Payment Directive existing at the time the applicable credit or payment was
    made. All applicable Payment Directives will expire twelve (12) months
    following the date issued unless the Payee takes all necessary action to
    withdraw any amounts previously directed by you. Any disputes regarding a
    Payment Directive will result in a temporary payment hold placed on your
    ability to withdraw any payment from the Service Account. If a Payment
    Directive dispute is not resolved within six (6) months following the date
    on which the financial hold was placed, the applicable Payment Directive
    will be deemed to have expired and will not be honored. Additionally,
    Company will be under no obligation to honor a Payment Directive until such
    time as the Service Account is in a payable (i.e., fully recouped) position.
    <br />
    <br />
    (c) Company will provide you with electronic access to Service Account
    statements detailing the calculation of Net Receipts and the basis for any
    credits made thereto. You will not receive physical copies of any Service
    Account statement, and it is your responsibility to review such statements
    once made available to you. Any objection relating to any accounting
    statement must be made (and any lawsuit commenced) no later than twelve (12)
    months after the date the statement is made available to you, and you hereby
    waive any longer statute of limitations that may be permitted by law.
    Company has the right to rely on the accuracy of any third-party statements
    and usage reports rendered to Company, and Company will not be liable for
    errors or omissions contained therein.
    <br />
    <br />
    (d) In the event that Company makes any overpayment of Net Receipts to you,
    Company will have the right to require you to reimburse Company the amount
    of the overpayment. Alternatively, to the extent that you owe any amounts to
    Company as a consequence of any overpayment (or violation of the terms
    herein), Company will have the right to deduct all or a portion of such
    amounts from any Net Receipts otherwise payable to you under this agreement
    (or any other agreement between you and Company), and the Term will be
    extended until such overpayment amount has been repaid.
    <br />
    <br />
    <br />
    <b>6. Additional Obligations</b>
    <br />
    <br />
    <br />
    (a) It is your responsibility to deliver all necessary information,
    metadata, recording files, graphic files, video files, or any other
    information files (collectively, “Content Files”) in the format required by
    Company or any applicable Platform. Company will have the right to format or
    reformat all Content Files to conform with any formats required by Company
    or by any Platform, as applicable. Notwithstanding the foregoing, you
    acknowledge that Company will not be obligated to distribute your Content
    through the Service until receipt of properly formatted Content Files.
    <br />
    <br />
    (b) Your Content (including any Content Files) may not contain any malicious
    code, computer virus, logos, chyrons, or overlay messaging of any kind, or
    include any so-called “bumpers,” pre-roll content, third party advertising,
    or promotional messaging of any kind.
    <br />
    <br />
    (c) You are solely responsible for securing and paying for digital
    phonorecord delivery, mechanical, public performance, and any other
    necessary licenses and permissions required from musical composition
    copyright owners (or their agents) in connection with Company’s exploitation
    of your Content hereunder, as well as all permissions, approvals, consents,
    authorizations, clearances, royalties, or other payments due to
    collaborators, performers, artists, producers, and others in connection with
    your Content and Merchandise and all payments that may be required under
    collective bargaining agreements or pursuant to any statutory schemes.
    <br />
    <br />
    (d) You will not (or permit any person, firm, or entity to) license,
    transfer, assign, encumber, pledge, securitize, monetize, or otherwise
    exploit your Content in any way that would interfere with Company’s full
    enjoyment of the rights granted herein and any attempt to do so will be void
    ab initio.
    <br />
    <br />
    (e) You will only access and use the Service for lawful purposes. You agree
    to abide by all applicable local, state, national, and foreign laws,
    treatises, and regulations in connection with your use of the Service,
    including applicable common law, all relevant statutes, and the rules and
    regulations of the Office of Foreign Assets Control of the U.S. Department
    of the Treasury.
    <br />
    <br />
    (f) You will at all times refrain from doing any of the following while
    accessing or using the Service: (i) disable, hack, circumvent, or otherwise
    interfere with security related features of the Service or features that
    prevent or restrict use or copying of any of Company’s content or materials;
    (ii) use any metadata, meta tags or other hidden text utilizing a Company
    trademark, URL, or product name; (iii) upload, submit, post, email, or
    otherwise transmit any unsolicited or unauthorized advertising, promotional
    materials, junk mail, spam, chain letters, so-called pyramid schemes or any
    other form of solicitation; (iv) forge any TCP/IP packet header or any part
    of the header information in any posting or in any way use the Service to
    send altered, deceptive, or false source-identifying information; (v)
    upload, submit, post, email, or otherwise transmit through the Service any
    content or other materials that are, in the sole opinion of Company,
    unlawful, harmful, threatening, obscene, harassing, defamatory or hateful,
    or that contain objects or symbols of hate, invade the privacy of any third
    party, contain nudity, are deceptive, threatening, abusive, inciting of
    unlawful action, defamatory, libelous, vulgar or violent or constitute hate
    speech, or are otherwise objectionable; (vi) destroy, interfere with or
    disrupt, or attempt to interfere with or disrupt, any web pages available on
    the Service, servers, or networks connected to the Service or the technical
    delivery systems of Company’s providers or break any requirements,
    procedures, policies or regulations, of networks connected to the Service;
    (vii) attempt to scan, probe, or test the vulnerability of any Company
    system or network, or breach, impair or circumvent any security or
    authentication measures protecting and providing security for the Service;
    (viii) attempt to decompile, disassemble, decipher or reverse engineer any
    of the software used to provide the Service; (ix) collect or store or
    attempt to collect or store personal data about other users Service without
    their express and explicit permission; (x) misrepresent or impersonate your
    affiliation with any person, firm, or entity, through pretext or some other
    form of social engineering or otherwise commit fraud; (xi) use the Service
    in any manner not permitted by the Terms of Use; (xii) directly or
    indirectly manipulate content Platform play counts through automated systems
    or any other means including with the intent to inflate, overcount, or
    exaggerate streams, plays, views, impressions, or outcomes; or (xiii)
    instruct, encourage, aid, or participate with any other individual to do any
    of the foregoing. Company will have no obligation whatsoever to credit your
    Service Account with any amounts generated in violation of any of the
    foregoing.
    <br />
    <br />
    (g) Except as otherwise required by law, you will not disclose (nor permit
    the disclosure of) any non-public ideas, applications, processes,
    techniques, programs, designs, drawings, documents, diagrams, manufacturing,
    marketing, financial or personnel data, sales information, supplier,
    customer, employee, or investor information, business plans, or any other
    information not then generally known to the public concerning or relating to
    Company or its products and services (“Confidential Information”) that is
    furnished or made available by Company or otherwise accessed by you in the
    performance of their respective obligations hereunder. you agrees to
    maintain the confidentiality of all Confidential Information and will not,
    directly or indirectly, during the Term hereof or at any time thereafter:
    (i) transfer or disclose any Confidential Information to any third party;
    (ii) use any Confidential Information for any purpose other than for the
    purpose of performing pursuant to this agreement; (iii) copy or otherwise
    reproduce any Confidential Information without Company’s prior written
    approval in each instance; (iv) use any Confidential Information for a
    purpose that is detrimental to Company, including the solicitation of
    Company’s employees or Company competitors, or the circumvention of Company
    with respect to business opportunities; or (v) take any other action with
    respect to any Confidential Information that is inconsistent with the
    confidential and proprietary nature thereof.
    <br />
    <br />
    <br />
    <b>7. Representations & Warranties</b>
    <br />
    <br />
    <br />
    You hereby represent and warrant that: (i) you have the full right, power,
    and authority to enter into and to fully perform the terms of this
    agreement, free and clear of any and all claims, rights, encumbrances, and
    obligations whatsoever; (ii) no part of your Content or Merchandise (or
    Company’s exploitation thereof) will violate or infringe upon the rights of
    any person, firm, or entity, including rights protected by contract,
    copyright, trademark, or rights of privacy and publicity; (iii) there are no
    current or pending legal claims, lawsuits, or judgments against your with
    regards to your Content or Merchandise, or the subject matter of this
    agreement; (iv) none of your Content (nor the performers and vocalists
    appearing thereon) is subject to any union or guild agreement; (v) except as
    specifically provided herein, Company will not be required to make any
    payment of any nature for, or in connection with, the acquisition, exercise,
    or exploitation of rights by Company pursuant to this agreement; (vi) you
    recognize the inherently speculative nature of the music business and affirm
    that Company has made no guarantees or promises of future success or
    particular outcomes with respect to your Content or Merchandise; and (vii)
    your will forego any claim that more revenue could have been made or better
    business could have been done than was actually made or done by Company
    (including its licensees) relative to your Content, or that better prices or
    terms could have been obtained in connection with the exploitation of
    thereof.
    <br />
    <br />
    <br />
    <b>8. General Provisions</b>
    <br />
    <br />
    <br />
    (a) Company reserves the sole right at any time to modify, discontinue, or
    terminate the Service or the terms thereof. It is your responsibility to
    check the Service terms applicable to any Content or Merchandise (which
    terms may be different than those in this agreement) prior to submitting the
    same to Company. By continuing to use or access the Service, you agree to be
    legally bound by the revised terms.
    <br />
    <br />
    (b) No breach (or alleged breach) by Company of any obligations hereunder
    will entitle you to bring an action or proceeding or affect any obligations
    hereunder, unless such breach (or alleged breach) has not been remedied
    within thirty (30) days following Company’s receipt of written notice
    detailing such breach (or alleged breach). The decision by Company to remedy
    such breach (or alleged breach) is not, of itself, an admission of
    liability. In no event whatsoever will you have any right to seek or obtain
    injunctive relief against Company (or any person, firm, or entity deriving
    rights therefrom) in connection with this agreement or otherwise in
    connection with your Content or Merchandise.
    <br />
    <br />
    (c) If Company is unable to carry out its material obligations hereunder due
    to an event outside of Company’s reasonable control such as illness,
    accident, an act or regulation of public authority, fire, riot, civil
    commotion, labor dispute, terrorist acts or threats, acts or declarations of
    war, disease, epidemic, pandemic, substantial interruption in (or
    substantial delay or failure of) technical facilities, failure (or
    substantial delay of) necessary transportation services, public emergencies,
    inclement weather, or acts of God (each, a “Force Majeure Event”), Company
    may (upon notice to you) suspend those obligations hereunder which impaired
    by such Force Majeure Event the duration thereof; provided that any
    suspension due to a Force Majeure Event will not exceed six (6) consecutive
    months in duration unless caused by your breach of this agreement.
    <br />
    <br />
    (d) In no event will Company be liable to you for any damages whatsoever,
    including indirect, incidental, special, punitive, or consequential damages
    arising out of or in connection with your use of the Service, irrespective
    of whether the damages are foreseeable and whether or not Company has been
    advised of the possibility of such damages. The foregoing limitation of
    liability will apply to the fullest extent permitted by law in the
    applicable jurisdiction.
    <br />
    <br />
    (e) You hereby release, waive, discharge, absolve, hold harmless, and
    covenant not to sue Company and its affiliates, officers, directors,
    employees, and agents, from any and all third-party claims, demands,
    liabilities, causes of action, or damages of any kind whatsoever arising out
    of or in connection with Company’s use of your Content or Merchandise as
    envisioned by this agreement, including all claims for copyright
    infringement, invasion of privacy, violation of the right of publicity or
    moral rights, or defamation. You hereby further indemnify, save, and hold
    Company and Company’s licensees, successors, and assignees harmless from any
    and all damages, liabilities, costs, losses, and expenses (including legal
    costs and attorneys’ fees reasonably incurred) arising out of or connected
    with any claim, demand, or action by a third party which is inconsistent
    with any of the representations, warranties, or covenants made by you in
    this agreement. In the event that Company learns of any such claim, or if
    Company reasonably anticipates such a claim may be forthcoming, Company may
    withhold any monies due to you hereunder pending resolution thereof.
    <br />
    <br />
    (f) Company may assign this agreement in whole or in part. You may not
    assign any rights or obligations under this agreement without Company’s
    prior written consent in each instance and any purported agreement will be
    void ab initio.
    <br />
    <br />
    (g) The relationship between you and Company is solely that of an ordinary
    contract and Company does not have any fiduciary or other special
    relationship with you by virtue of this agreement. Nothing herein will
    obligate Company to make a specific use of your Content or Merchandise or to
    exercise any of the rights granted to Company hereunder. Further, nothing
    herein, expressed or implied, will constitute or contemplate a partnership,
    joint venture, employment, or other similar relationship between you and
    Company.
    <br />
    <br />
    (h) This agreement is for the sole benefit of the parties hereto and their
    respective successors and permitted assignees. Nothing herein, expressed or
    implied, is intended to or confers upon any other person, firm, or entity
    any legal or equitable right, benefit, or remedy under or in connection with
    this agreement.
    <br />
    <br />
    (i) Upon request, you will use commercially reasonable efforts to deliver or
    cause to be delivered to Company such additional documents and to take or
    cause to be taken such further actions as may reasonably be necessary,
    proper, or advisable to make evidence of or effectuate the rights granted by
    you to Company, or to otherwise carry out the provisions hereof.
    <br />
    <br />
    (j) All notices to be given by Company will be to the address and email
    address listed for you in your Service Account. All notices to Company will
    be in writing and may be delivered electronically to legal@trac.co provided
    that a physical copy of any such notice is sent simultaneously and delivered
    by overnight courier or by United States certified mail, postage prepaid,
    return receipt requested to Trac Technologies, Inc., P.O. Box 1511, Santa
    Monica, CA 90406, Attention: Legal Notice Department.
    <br />
    <br />
    (k) You acknowledge that you have been represented by independent counsel or
    have had the unrestricted opportunity to consult with independent counsel of
    your own choice in connection with this agreement and that any failure by
    you to retain independent counsel will not affect the enforceability or
    interpretation hereof.
    <br />
    <br />
    <br />
    <b>9. Dispute Resolution:</b>
    <br />
    <br />
    <br />
    In the event of any controversy or claim between the parties arising out of
    or relating to this agreement, or the breach thereof, including its
    formation, validity, construction, scope, performance, breach, or
    cancellation (including the formation, validity, construction, scope,
    performance, breach, and or cancellation of this arbitration clause), such
    claim or controversy will be resolved in Los Angeles, California through
    confidential and binding arbitration in accordance with the Commercial Rules
    of the American Arbitration Association with Expedited Procedure and
    Optional Appeal under the laws of the state of California without regard to
    conflicts of laws principles. Notwithstanding the foregoing mandatory
    arbitration provisions: (i) except as otherwise provided herein, Company may
    seek, and any state or federal court of competent jurisdiction is authorized
    to provide, interim injunctive or other equitable relief in aid of
    arbitration of any claim between the parties pursuant to this agreement;
    (ii) if any party fails or refuses to participate in the arbitration,
    including the payment of that party’s share of the arbitration fees, the
    party demanding arbitration will have the authority (but not the obligation)
    to file suit against the non-participating party in any state or federal
    court of competent jurisdiction; and (iii) if Company is sued or joined in a
    third-party action relative to your Content or Merchandise, Company will be
    entitled to pursue any related counterclaims, crossclaims, or third-party
    claims against you in connection with such action, and you hereby consents
    to the jurisdiction of the court and forum where the action is pending.
    <br />
    <br />
    <br />
    <b>10. Entire Agreement:</b>
    <br />
    <br />
    <br />
    This document sets forth the entire understanding of the parties hereto
    relating to the subject matter hereof, and all prior or contemporaneous
    negotiations, understandings, agreements, and the like are superseded by and
    merged into the agreement reflected herein. Any exhibits or schedules
    attached or appended hereto are expressly incorporated herein and all
    references to this agreement will be interpreted to include any such
    exhibits or schedules. No modification, amendment, waiver, or discharge of
    this agreement or any of the terms or provisions hereof will be binding
    unless done in writing. The invalidity or unenforceability of any provision
    hereof will not affect the validity or enforceability of any other provision
    hereof. As used herein, the word “including” is nonrestrictive, and the word
    “or” is disjunctive but nonexclusive unless otherwise stated. Any paragraph
    headings are included only as a general guide to the contents thereof and do
    not control, enlarge, or restrict the terms or meaning of those paragraphs.
    If any legal proceeding is brought by either party hereto to enforce or
    interpret this agreement or any of the terms contained herein, both parties
    will be deemed to have jointly drafted this agreement, and neither party
    will enjoy the benefit of any evidentiary presumptions based upon the
    identity of the drafter hereof. This agreement will not be binding until
    signed by both parties and may be executed digitally and in counterparts or
    duplicate originals, each of which (including digital copies thereof) is
    deemed an original for all purposes.
    <br />
    <br />
    <br />
  </>
);

const StyledTable = styled.table`
  border: solid 1px black;
  border-collapse: collapse;
  width: 100%;
  td {
    border: solid 1px black;
    text-align: center;
    height: 50px;
  }
  th {
    border: solid 2px black;
    height: 60px;
    font-weight: bold;
    font-style: italic;
  }
`;
export default Dos;
